import React, { ReactNode } from "react"
import {
  Badge, BadgeProps, Text, TextProps,
} from "@chakra-ui/react"
import {
  PASS_BUILDER_PREVIEW_SECTION_TITLE_FONT_SIZE,
  PASS_BUILDER_PREVIEW_SECTION_TITLE_LETTER_SPACING,
  PASS_BUILDER_PREVIEW_SECTION_TITLE_LINE_HEIGHT,
} from "./passBuilderTokens"

type PassBuilderTextProps = TextProps & {
  children: ReactNode
}

export const PassBuilderSectionTitle = ({
  children,
  primary = false,
  ...props
}: PassBuilderTextProps & { primary?: boolean }) => (
  <Text
    fontSize={primary ? "30px" : "24px"}
    fontWeight="medium"
    lineHeight={primary ? "45px" : "26px"}
    color="black"
    {...props}
  >
    {children}
  </Text>
)

export const PassBuilderFieldTitle = ({ children, ...props }: PassBuilderTextProps) => (
  <Text
    fontSize="18px"
    fontWeight="extrabold"
    lineHeight="27px"
    color="black"
    {...props}
  >
    {children}
  </Text>
)

export const PassBuilderBodyText = ({ children, ...props }: PassBuilderTextProps) => (
  <Text
    fontSize="16px"
    fontWeight="medium"
    lineHeight="24px"
    color="black"
    {...props}
  >
    {children}
  </Text>
)

export const PassBuilderFieldRowLabel = ({ children, ...props }: PassBuilderTextProps) => (
  <PassBuilderBodyText
    w="53px"
    flexShrink={0}
    lineHeight="40px"
    {...props}
  >
    {children}
  </PassBuilderBodyText>
)

export const PassBuilderHelpText = ({ children, ...props }: PassBuilderTextProps) => (
  <Text
    fontSize="14px"
    fontWeight="medium"
    lineHeight="20px"
    color="gray.600"
    {...props}
  >
    {children}
  </Text>
)

export const PassBuilderPlatformLabel = ({ children, ...props }: PassBuilderTextProps) => (
  <Text
    fontSize="14px"
    fontWeight="extrabold"
    color="black"
    {...props}
  >
    {children}
  </Text>
)

export const PassBuilderPreviewSectionTitle = ({ children, ...props }: PassBuilderTextProps) => (
  <Text
    fontSize={PASS_BUILDER_PREVIEW_SECTION_TITLE_FONT_SIZE}
    fontWeight="semibold"
    lineHeight={PASS_BUILDER_PREVIEW_SECTION_TITLE_LINE_HEIGHT}
    letterSpacing={PASS_BUILDER_PREVIEW_SECTION_TITLE_LETTER_SPACING}
    color="gray.500"
    textAlign="center"
    textTransform="uppercase"
    w="full"
    {...props}
  >
    {children}
  </Text>
)

export const PassBuilderPlatformTabLabel = ({
  children,
  ...props
}: PassBuilderTextProps) => (
  <Text
    fontSize="16px"
    fontWeight="extrabold"
    lineHeight="18px"
    color="black"
    {...props}
  >
    {children}
  </Text>
)

export const PassBuilderStatusBadge = ({ children, ...props }: BadgeProps) => (
  <Badge
    variant="subtle"
    fontSize="14px"
    fontWeight="medium"
    textTransform="none"
    {...props}
  >
    {children}
  </Badge>
)

export const PassBuilderDescription = ({ children, ...props }: PassBuilderTextProps) => (
  <PassBuilderBodyText whiteSpace="pre-line" mb={4} {...props}>
    {children}
  </PassBuilderBodyText>
)
